import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

import { CompanyOrderDetails } from 'src/app/components/company/models/company-order-details.type';
import { PhotographerOrderDetails } from '../../../models/photographer/photographer-order-details.model';
import { CommentItem } from '../../models/comment-item.model';
import { UtilitiesService } from '../../services/utilities.service';
import { UtilityFunctions } from '../../utilities/functions.models';
import { GraphQLService } from '../../../services/graph-ql.service';
import { AppService } from '../../../app.service';
import { SharedQueries } from '../../../models/shared/enums/get-query';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { MutationQuery } from '../../../models/shared/enums/mutation-query.enum';

@Component({
  standalone: false,
  selector: 'bt-sidebar-comments',
  templateUrl: './sidebar-comments.component.html',
  styleUrls: ['./sidebar-comments.component.scss']
})
export class SidebarCommentsComponent implements OnInit {

  @Input() orderId: number;
  @Input() style: CompanyOrderDetails | PhotographerOrderDetails;

  readonly #graphQLService = inject(GraphQLService);
  readonly #appService = inject(AppService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #utilitiesService = inject(UtilitiesService);

  comments: { data: Array<CommentItem>, page?: number, size: number } = {
    data: [],
    size: 20
  }

  loaderId = UtilityFunctions.newGuid();
  overflowDiv = UtilityFunctions.newGuid();
  message: string;
  imgPath: string;

  constructor(
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    if (this.orderId) this.getComments(0);
  }

  getComments(page: number) {
    this.comments.page = page;
    if (this.style) {
      const filters = {
        currentUserId: this.#appService.user.userId,
        orderId: this.orderId,
        paginationPage: this.comments.page,
        paginationSize: this.comments.size,
        modelId: this.style.modelId,
        colorId: this.style.colorId,
        sizeGroupId: null
      }

      this.#graphQLService.getData(SharedQueries.GET_STYLE_SHOTS_COMMENTS, filters)
      .pipe(takeUntilDestroyed(this.#destroyRef), map((res: any) => res['data']['styleShotsComments']['nodes']))
      .subscribe((data: Array<CommentItem>) => this.mapData(data));
    } else {
      this.commonService.getOrderComments(this.orderId, this.comments.page, this.comments.size, this.loaderId)
        .subscribe(data => this.mapData(data));
    }
  }

  onSendMessage() {
    const text = this.message;
    this.message = '';
    if (!!text?.trim()) {
      if (this.style) {
        const data = {
          currentUserId: this.#appService.user.userId,
          orderId: this.orderId,
          sizeGroupId: null,
          colorId: this.style.colorId,
          modelId: this.style.modelId,
          imgPath: this.imgPath,
          text: text
        }
        this.#graphQLService.postData( MutationQuery.INSERT_STYLE_SHOTS_COMMENT, data)
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe((data: any) => this.getComments(0));
      } else {
        const data = {
          currentUserId: this.#appService.user.userId,
          orderId: this.orderId,
          text: text,
          imgPath: this.imgPath
        }
        this.#graphQLService.postData(MutationQuery.INSERT_ORDER_COMMENT, data)
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe((data: any) => this.getComments(0));
      }
    } else {
      this.#utilitiesService.showSnackbar('Empty message!');
    }
  }

  private mapData(data: CommentItem[]) {
    if (!this.comments.page) {
      this.comments.data = data;
      setTimeout(() => {
        const el = document.getElementById(this.overflowDiv);
        if (el) el.scrollTop = el.scrollHeight;
      });
    } else {
      this.comments.data.unshift(...data);
    }
  }
}
